import React, { useCallback, useState } from 'react'
import { PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js'
import styled from 'styled-components'

import Button from 'components/reusable/button'
import { colors } from 'helpers/colors'
import LoadingIndicator from 'components/reusable/loading/LoadingIndicator'

function AddCardForm({ loading, border, onCancel, disabled, onSubmit, submitLabel = 'Submit' }) {
  const [ready, setReady] = useState(false)
  const [isCardComplete, setIsCardComplete] = useState(false)
  const elements = useElements()
  const stripe = useStripe()

  const handleReady = useCallback(() => setReady(true), [setReady])
  const handleChange = useCallback((event) => setIsCardComplete(event.complete), [setIsCardComplete])

  const handleSubmit = useCallback(() => {
    if (!elements) return
    onSubmit(elements, stripe)
  }, [elements, onSubmit, stripe])

  return (
    <AddCardFormWrapper $border={ready ? border : 'none'} id="AddCardFormWrapper">
      <PaymentElement onReady={handleReady} onChange={handleChange} />

      {ready ? (
        <ButtonToolbar>
          <Button
            loading={loading}
            height={40}
            disabled={disabled || !elements || !isCardComplete}
            onClick={handleSubmit}
            type="primary"
          >
            {submitLabel}
          </Button>

          <CancelButton height={40} disabled={disabled} onClick={onCancel} type="gray-shadow">
            Cancel
          </CancelButton>
        </ButtonToolbar>
      ) : (
        <LoadingContainer>
          <LoadingIndicator />
        </LoadingContainer>
      )}
    </AddCardFormWrapper>
  )
}

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`

const ButtonToolbar = styled.div`
  margin-top: auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const CancelButton = styled(Button)`
  display: none;

  @media (max-width: 768px) {
    display: inline-block;
  }
`

const AddCardFormWrapper = styled.div`
  width: 100%;
  max-width: min(400px, 100%);
  background: ${colors.light};
  border: ${({ $border }) => $border || `1px solid ${colors.gray[100]}`};
  padding: ${({ $border }) => ($border === 'none' ? 0 : '16px')};
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-family: 'Gotham Pro', sans-serif;
  @media (max-width: 768px) {
    min-height: 100%;
    border: none;
  }
`

export default AddCardForm
